// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import WaterMarkContainer, { WaterMarkContainerNew } from '../styles/OutOfStockWaterMark.style';

const OutOfStockWaterMark = ({ label, fontSizes, fromBundleOrOutFit, className, isFavPage }) => {
  return fromBundleOrOutFit ? (
    <WaterMarkContainerNew fromBundleOrOutFit={fromBundleOrOutFit} className={className}>
      <BodyCopy className={'body-text-new'}>{label}</BodyCopy>
    </WaterMarkContainerNew>
  ) : (
    <WaterMarkContainer fromBundleOrOutFit={fromBundleOrOutFit}>
      <div className={`${isFavPage ? 'fav-redesign' : ''}`}>
        <BodyCopy
          fontFamily="secondary"
          fontSize={fontSizes}
          fontWeight={isFavPage ? 'bold' : 'extrabold'}
          color={isFavPage ? 'white' : 'gray[900]'}
          textAlign="center"
        >
          {label}
        </BodyCopy>
      </div>
    </WaterMarkContainer>
  );
};

OutOfStockWaterMark.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  fontSizes: PropTypes.shape([]),
  fromBundleOrOutFit: PropTypes.bool,
};

OutOfStockWaterMark.defaultProps = {
  className: '',
  fontSizes: ['fs12', 'fs12', 'fs14'],
  fromBundleOrOutFit: false,
};

export default withStyles(OutOfStockWaterMark);
